module.exports = __webpack_public_path__ + "img/IMG_2607.61e6524e.jpg";